import { axiosNT } from '../../../services/axios';

export const getQuestionList = async (clientId: string, params: string) => {
    let questionList: any = [];
    try {
        const response: any = await axiosNT
        .get(`/question/getQuestionListonDateRange/${clientId}?${params}`);
        response.responseObject.forEach((test: any) => {
            if (!test.firstName && !test.lastName) {
                test.firstName = test.email
                test.lastName = ''
            }
            if (!test.firstPublishDate) {
                test.firstPublishDate = test.createdAt
            }
        })
        return response;
    } catch{
    }
    return questionList;
}

export const getTestList = async (clientId: string, params: string) => {
    let testList: any = []
    try {
        const response: any = await axiosNT
            .get(`/test/getTestListonDateRange/${clientId}?${params}`);
        response.responseObject.forEach((test: any) => {
            if (!test.firstName && !test.lastName) {
                test.firstName = test.email
                test.lastName = ''
            }
            if (!test.firstPublishDate) {
                test.firstPublishDate = test.createdAt
            }
        })
        return response;
    } catch{
    }
    return testList;
}

export const generateQuestionReport = async (payload: any) => {
    let questionReport: any = []
    try {
        const response: any = await axiosNT
            .post('/question/generate-question-report',payload);
        
        return response;
    } catch{
        console.log('error');
    }
    return questionReport;
}

export const generateIssueReport = async (startDate: string, endDate: string, clientList: any) => {
    let issueReport: any = [];
    try {
        const response: any = await axiosNT
            .post(`/question-reviews/report?startDate=${startDate}&endDate=${endDate}`,{clientIds: clientList});
        return response;
    } catch {
        console.log('error');
    }
    return issueReport;
}

export const QUESTION_CREATE_REPORTS = {
    SCHOOL_ORG: {
        id: '5d1f2f39d3e44e5426aab2fe',
        name: 'FIIT-JEE'
    },
    MAX_OPTION: 2
};

export const REPORT_MENU = {
    HOME: 'home',
    QUESTION: 'question',
    ISSUE: 'issue',
}

export const OBJECT_DATA = {
    S_NO: 'S.No',
    QID: 'QID',
    QUESTION_TYPE: 'Question Type',
    CREATED_BY:	'Created By',
    DIGITIZED_BY: 'Digitized By',
    REPORTED_BY: 'Reported By',
    REPORTER_TYPE: 'Reporter Type',
    REPORTED_ON: 'Reported On',
    STATUS:	'Status',
    ERROR_TYPE:	'Error Type',
    ERROR_DESCRIPTION: 'Error Description',
    ATTACHMENT_LINKS: 'Attachment Links',
    NA: 'NA',
    FILE_NAME: 'Reported Issues',
    SUCCESS: 'success',
    ERROR: 'error',
    SUCCESS_CODE: 200,
    ERROR_MESSAGE: 'Report Could not be downloaded',
    SUCCESS_MESSAGE: 'Report Downloaded successfully',
}

export const KEY_ARRAYS = ['S.No', 'Client Name', 'QID', 'Question Type', 'Created By', 'Digitized By', 'Reported By', 'Reporter Type', 'Reported On',	'Status', 'Error Type', 'Error Description', 'Attachment Links',]